import React from 'react';
import { Location } from 'types/venue';
import { getValueSafely } from 'utils/utils';

export default function LocationSpan({ location }: { location?: Location }) {
  if (location !== null && location !== undefined) {
    const assetIsOutdoor = location.is_outdoors;
    return assetIsOutdoor ? (
      <span>
        <div>Outside Mapped Buildings</div>
        <div style={{ color: '#CCCCCB', margin: '5px 0' }}>Possible region(s):</div>
        <div>{getValueSafely(location.region?.name)}</div>
      </span>
    ) : (
      <span>
        <div>
          {location.building_level.level.name}
          <br />
          {location.building_level.possible_buildings[0].name}
        </div>

        <div style={{ color: '#CCCCCB', margin: '5px 0' }}>Possible region(s):</div>
        <div>{getValueSafely(location.region?.name)}</div>
      </span>
    );
  }
  return <span>––</span>;
}
